/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLinkMinus = createReactComponent("link-minus", "IconLinkMinus", [
  ["path", { d: "M9 15l6 -6", key: "svg-0" }],
  [
    "path",
    { d: "M11 6l.463 -.536a5 5 0 1 1 7.071 7.072l-.534 .464", key: "svg-1" }
  ],
  [
    "path",
    {
      d: "M12.603 18.534a5.07 5.07 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463",
      key: "svg-2"
    }
  ],
  ["path", { d: "M16 19h6", key: "svg-3" }]
]);

export { IconLinkMinus as default };
//# sourceMappingURL=IconLinkMinus.js.map
